import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';

const TextField = ({
  input,
  type,
  placeholder,
  label,
  style,
  meta: { error, touched }
}) => {
  return (
    <FormGroup>
      <Label>{label}</Label>
      <Input {...input} type={type} style={style} placeholder={placeholder} />
      <div className="text-danger" style={{ marginBottom: '20px' }}>
        {touched && error}
      </div>
    </FormGroup>
  );
};

export default TextField;



// WEBPACK FOOTER //
// ./src/components/common/TextField.js